var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    { tag: "component" },
    [
      _vm.showMore
        ? _c("span", [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])
        : _c("span", [_vm._v("\n    " + _vm._s(_vm.truncatedText) + "\n  ")]),
      _vm._v(" "),
      _vm.text
        ? _c("icon", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.right",
                value: _vm.showMoreButtonText,
                expression: "showMoreButtonText",
                modifiers: { right: true },
              },
            ],
            staticClass:
              "small clickable small text-primary show-more-button pl-1",
            attrs: { name: _vm.showMoreButtonIcon },
            on: { click: _vm.toggleShowMore },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }